import { useGetRoles } from '@vindr/services/actions/role.action';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';

interface RolesProps extends FormItemProps {
  searchVietnamese?: boolean;
  props?: any;
}

const Roles = ({
  name = 'roles',
  label = 'Roles',
  placeholder = 'Select Role',
  rules,
  required = true,
  disabled,
  searchVietnamese = true,
  props,
}: RolesProps) => {
  const { t } = useTranslation('Vindoc');
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetRoles({
    limit: 100,
    offset: 0,
    ...(searchTerm && { name: searchTerm }),
  });

  const roles = data?.data?.data;

  const rulesMemo = useMemo(() => {
    if (rules) return rules;
    const rulesState = [];

    if (required)
      rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules]);

  return (
    <FormSelect
      {...{ name, label, placeholder }}
      mode="multiple"
      rules={rulesMemo}
      loading={isInitialLoading || isRefetching}
      disabled={disabled}
      searchVietnamese={searchVietnamese}
      onSearch={handleSearch}
      showSearch
      {...props}
    >
      {roles?.map((role) => (
        <Select.Option key={role.id} value={role.code}>
          {role.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Roles;
